// Fermer un .banner via bouton .banner__close
document.addEventListener('click', (e) => {
    const btn = e.target.closest('.banner__close');
    if (btn) btn.closest('.banner')?.remove();
});
